"use client";

/**
 * Иконочный пак YUC Portal — рисованные векторы, грид 24×24, currentColor.
 * Использование:  <IconPlanning size={16} />  ·  <IconLaunch size={20} duotone />
 * Превью всех иконок: /icons (только dev).
 *
 * Правила пака — см. components/ui/icons/icon-base.tsx и docs/reference/icon-pack.md.
 * ⚠️ Внутри <svg> НЕ добавлять transform/filter — ломается prod-сборка.
 */
import { makeIcon, Duo, Dot } from "./icon-base";

/* ═══════════════════════ МОДУЛИ ПОРТАЛА ═══════════════════════ */

/** Аналитика WB · графики · статистика (wb_analytics) */
export const IconAnalytics = makeIcon("IconAnalytics", (d) => (
  <>
    <Duo on={d}>
      <rect x="16.25" y="3.5" width="4.5" height="17" rx="1.75" />
    </Duo>
    <rect x="3.25" y="13.5" width="4.5" height="7" rx="1.75" />
    <rect x="9.75" y="8.5" width="4.5" height="12" rx="1.75" />
    <rect x="16.25" y="3.5" width="4.5" height="17" rx="1.75" />
  </>
));

/** План YUC · план-факт · динамика (plan_yuc) */
export const IconPlanChart = makeIcon("IconPlanChart", (d) => (
  <>
    <Duo on={d}>
      <path d="M7.5 16 11 11l3 2.5 5.5-6.9V20H7.5z" />
    </Duo>
    <path d="M3.5 3.5v14a2.5 2.5 0 0 0 2.5 2.5h14.5" />
    <path d="M7.5 16 11 11l3 2.5 5.5-6.9" />
  </>
));

/** Планирование · чек-лист · план сезона (planning) */
export const IconPlanning = makeIcon("IconPlanning", (d) => (
  <>
    <Duo on={d}>
      <rect x="5" y="4.5" width="14" height="16" rx="2.5" />
    </Duo>
    <path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="2.5" width="6" height="4" rx="1.5" />
    <path d="M8.75 13.25 11 15.5l4.25-4.75" />
  </>
));

/** Ассортиментная матрица (assortment) */
export const IconAssortment = makeIcon("IconAssortment", (d) => (
  <>
    <Duo on={d}>
      <rect x="13" y="13" width="7.5" height="7.5" rx="2.25" />
    </Duo>
    <rect x="3.5" y="3.5" width="7.5" height="7.5" rx="2.25" />
    <rect x="13" y="3.5" width="7.5" height="7.5" rx="2.25" />
    <rect x="3.5" y="13" width="7.5" height="7.5" rx="2.25" />
    <rect x="13" y="13" width="7.5" height="7.5" rx="2.25" />
  </>
));

/** Коллекция R&D · слои коллекции (rd_collection) */
export const IconCollection = makeIcon("IconCollection", (d) => (
  <>
    <Duo on={d}>
      <path d="m12 2.75 9 4.75-9 4.75-9-4.75z" />
    </Duo>
    <path d="m12 2.75 9 4.75-9 4.75-9-4.75z" />
    <path d="m3.5 12.25 8.5 4.5 8.5-4.5" />
    <path d="m3.5 16.75 8.5 4.5 8.5-4.5" />
  </>
));

/** Запуск продукта (product_launch) */
export const IconLaunch = makeIcon("IconLaunch", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 2.6c3 2.6 4.6 6.2 4.6 10.2l-1.9 3.2H9.3l-1.9-3.2C7.4 8.8 9 5.2 12 2.6z" />
    </Duo>
    <path d="M12 2.6c3 2.6 4.6 6.2 4.6 10.2l-1.9 3.2H9.3l-1.9-3.2C7.4 8.8 9 5.2 12 2.6z" />
    <circle cx="12" cy="9.5" r="2.1" />
    <path d="M9.3 16H7.1l-2.4 3.4 3.2-.5.6 2.5 2.3-3.4" />
    <path d="M14.7 16h2.2l2.4 3.4-3.2-.5-.6 2.5-2.3-3.4" />
  </>
));

/** Чип · отдел IT (ai) в рельсе отделов */
export const IconChip = makeIcon("IconChip", (d) => (
  <>
    <Duo on={d}>
      <rect x="9" y="9" width="6" height="6" rx="1.5" />
    </Duo>
    <rect x="5.5" y="5.5" width="13" height="13" rx="3" />
    <rect x="9" y="9" width="6" height="6" rx="1.5" />
    <path d="M9 2.5v3M15 2.5v3M9 18.5v3M15 18.5v3M2.5 9h3M2.5 15h3M18.5 9h3M18.5 15h3" />
  </>
));

/** Дашборд отдела · фолбэк-иконка модуля/отдела */
export const IconDashboard = makeIcon("IconDashboard", (d) => (
  <>
    <Duo on={d}>
      <rect x="3.5" y="3.5" width="7.5" height="17" rx="2.25" />
    </Duo>
    <rect x="3.5" y="3.5" width="7.5" height="17" rx="2.25" />
    <rect x="13" y="3.5" width="7.5" height="7" rx="2.25" />
    <rect x="13" y="13.5" width="7.5" height="7" rx="2.25" />
  </>
));

/** Задачи · доска (it_tasks) */
export const IconTasks = makeIcon("IconTasks", (d) => (
  <>
    <Duo on={d}>
      <rect x="3.5" y="3.5" width="17" height="5.5" rx="2" />
    </Duo>
    <rect x="3.5" y="3.5" width="17" height="5.5" rx="2" />
    <rect x="3.5" y="12.5" width="7.5" height="8" rx="2" />
    <rect x="13" y="12.5" width="7.5" height="8" rx="2" />
  </>
));

/** Трекер разработок · мензурка с мерными делениями (dev_tracker) */
export const IconBeaker = makeIcon("IconBeaker", (d) => (
  <>
    <Duo on={d}>
      <path d="M8 13.5h8v4.5a2.5 2.5 0 0 1-2.5 2.5h-3A2.5 2.5 0 0 1 8 18z" />
    </Duo>
    <path d="M8 3.5v14.5a2.5 2.5 0 0 0 2.5 2.5h3a2.5 2.5 0 0 0 2.5-2.5V3.5" />
    <path d="M6.5 3.5h11" />
    <path d="M8 13.5h8" />
    <path d="M8 7.25h2.25M8 10.375h2.25" />
  </>
));

/** R&D · лаборатория · колба (отдел R&D) */
export const IconFlask = makeIcon("IconFlask", (d) => (
  <>
    <Duo on={d}>
      <path d="M7.6 15.5h8.8l3 5.2a1 1 0 0 1-.87 1.5H5.47a1 1 0 0 1-.87-1.5z" />
    </Duo>
    <path d="M9.5 2.75v6.4a3 3 0 0 1-.4 1.5l-4.5 7.8a2.2 2.2 0 0 0 1.9 3.3h11a2.2 2.2 0 0 0 1.9-3.3l-4.5-7.8a3 3 0 0 1-.4-1.5v-6.4" />
    <path d="M8.25 2.75h7.5" />
    <path d="M7.6 15.5h8.8" />
  </>
));

/** Фабрика контента · генерация (content_factory, AI) */
export const IconWand = makeIcon("IconWand", (d) => (
  <>
    <Duo on={d}>
      <path d="m13.6 6.6 3.8 3.8-8.9 8.9-3.8-3.8z" />
    </Duo>
    <path d="M4.7 15.5 15.5 4.7a1.6 1.6 0 0 1 2.3 0l1.5 1.5a1.6 1.6 0 0 1 0 2.3L8.5 19.3a1.6 1.6 0 0 1-2.3 0l-1.5-1.5a1.6 1.6 0 0 1 0-2.3z" />
    <path d="m13.6 6.6 3.8 3.8" />
    <path d="M5.5 3.5v3M4 5h3" />
    <path d="M19 15.5v2.5M17.75 16.75h2.5" />
  </>
));

/** Сценарии · workflow · граф нод (workflows) */
export const IconWorkflow = makeIcon("IconWorkflow", (d) => (
  <>
    <Duo on={d}>
      <rect x="3" y="3" width="6.5" height="6.5" rx="2" />
    </Duo>
    <rect x="3" y="3" width="6.5" height="6.5" rx="2" />
    <rect x="14.5" y="3" width="6.5" height="6.5" rx="2" />
    <rect x="8.75" y="14.5" width="6.5" height="6.5" rx="2" />
    <path d="M9.5 6.25h5" />
    <path d="M6.25 9.5v2.75a1.5 1.5 0 0 0 1.5 1.5h1" />
    <path d="M17.75 9.5v2.75a1.5 1.5 0 0 1-1.5 1.5h-1" />
  </>
));

/** Telegram-боты · управление ботами (telegram_bots) */
export const IconBot = makeIcon("IconBot", (d) => (
  <>
    <Duo on={d}>
      <rect x="3.5" y="7.5" width="17" height="12" rx="4" />
    </Duo>
    <rect x="3.5" y="7.5" width="17" height="12" rx="4" />
    <path d="M12 3v4.5" />
    <Dot cx={12} cy={2.6} r={1.35} />
    <Dot cx={8.75} cy={13} r={1.3} />
    <Dot cx={15.25} cy={13} r={1.3} />
    <path d="M9.5 16.75h5" />
    <path d="M1.75 11.5v4M22.25 11.5v4" />
  </>
));

/** Отзывы WB (wb_reviews) */
export const IconReviews = makeIcon("IconReviews", (d) => (
  <>
    <Duo on={d}>
      <path d="M6 3.5h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6.4L7 20.4V16.5H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" />
    </Duo>
    <path d="M6 3.5h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6.4L7 20.4V16.5H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" />
    <path d="M12 6.2l.97 2.27 2.45.22-1.85 1.62.55 2.4L12 11.45l-2.12 1.26.55-2.4-1.85-1.62 2.45-.22z" />
  </>
));

/** Этикетки · артикул (label_maker) */
export const IconLabel = makeIcon("IconLabel", (d) => (
  <>
    <Duo on={d}>
      <path d="M11.6 2.9H19a2 2 0 0 1 2 2v7.4a2 2 0 0 1-.59 1.42l-7.1 7.1a2 2 0 0 1-2.83 0l-8.8-8.8a2 2 0 0 1 0-2.83l7.1-7.1A2 2 0 0 1 11.6 2.9z" />
    </Duo>
    <path d="M11.6 2.9H19a2 2 0 0 1 2 2v7.4a2 2 0 0 1-.59 1.42l-7.1 7.1a2 2 0 0 1-2.83 0l-8.8-8.8a2 2 0 0 1 0-2.83l7.1-7.1A2 2 0 0 1 11.6 2.9z" />
    <circle cx="16.4" cy="7.6" r="1.6" />
  </>
));

/** Роадмап · маршрут (roadmap) */
export const IconRoadmap = makeIcon("IconRoadmap", (d) => (
  <>
    <Duo on={d}>
      <circle cx="6.5" cy="5.5" r="2.75" />
    </Duo>
    <circle cx="6.5" cy="5.5" r="2.75" />
    <circle cx="17.5" cy="18.5" r="2.75" />
    <path d="M9.25 5.5h5.25a3.5 3.5 0 0 1 0 7h-5a3.5 3.5 0 0 0 0 7h5.25" />
  </>
));

/** Отчёты креаторов · видео (creator_reports) */
export const IconVideo = makeIcon("IconVideo", (d) => (
  <>
    <Duo on={d}>
      <rect x="2.5" y="4.5" width="14" height="15" rx="3.5" />
    </Duo>
    <rect x="2.5" y="4.5" width="14" height="15" rx="3.5" />
    <path d="m16.5 10.25 3.6-2.55a1 1 0 0 1 1.4.82v6.96a1 1 0 0 1-1.4.82l-3.6-2.55z" />
    <path d="m8 9.4 3.75 2.6L8 14.6z" />
  </>
));

/** Калькулятор упаковки (packaging_calc) */
export const IconCalculator = makeIcon("IconCalculator", (d) => (
  <>
    <Duo on={d}>
      <rect x="7.75" y="6" width="8.5" height="3.75" rx="1.25" />
    </Duo>
    <rect x="4.5" y="2.5" width="15" height="19" rx="3.5" />
    <rect x="7.75" y="6" width="8.5" height="3.75" rx="1.25" />
    <Dot cx={8.25} cy={13.25} />
    <Dot cx={12} cy={13.25} />
    <Dot cx={15.75} cy={13.25} />
    <Dot cx={8.25} cy={17.25} />
    <Dot cx={12} cy={17.25} />
    <Dot cx={15.75} cy={17.25} />
  </>
));

/* ═══════════════════════ ОТДЕЛЫ ═══════════════════════ */

/** Маркетинг · рупор (отдел marketing) */
export const IconMegaphone = makeIcon("IconMegaphone", (d) => (
  <>
    <Duo on={d}>
      <path d="M20 4.25v15.5L8.5 15.5v-7z" />
    </Duo>
    <path d="M20 4.25v15.5a1 1 0 0 1-1.35.94L8.5 15.5v-7L18.65 3.3A1 1 0 0 1 20 4.25z" />
    <path d="M8.5 8.5H5.25a2.75 2.75 0 0 0 0 5.5H8.5" />
    <path d="M7 14.25 8.6 20a1.5 1.5 0 0 0 2.9-.8l-1.2-4.2" />
  </>
));

/** Продажи · рост (отдел sales) */
export const IconTrend = makeIcon("IconTrend", (d) => (
  <>
    <Duo on={d}>
      <path d="m3 18 5.5-5.5 3.5 3.5 6-6V20H3z" />
    </Duo>
    <path d="m2.75 17.75 5.75-5.75 3.5 3.5 8.25-8.25" />
    <path d="M15.25 7.25h5.75v5.75" />
  </>
));

/** Финансы · кошелёк (отдел finance) */
export const IconWallet = makeIcon("IconWallet", (d) => (
  <>
    <Duo on={d}>
      <rect x="2.5" y="5.5" width="19" height="14" rx="3.5" />
    </Duo>
    <path d="M2.5 9a3.5 3.5 0 0 1 3.5-3.5h11a3.5 3.5 0 0 1 3.5 3.5" />
    <rect x="2.5" y="5.5" width="19" height="14" rx="3.5" />
    <path d="M21.5 10.5h-4a2.5 2.5 0 0 0 0 5h4" />
    <Dot cx={17.75} cy={13} r={0.9} />
  </>
));

/* ═══════════════════════ ДОМЕНЫ ═══════════════════════ */

/** Себестоимость · деньги · монеты (cost_price) */
export const IconCoins = makeIcon("IconCoins", (d) => (
  <>
    <Duo on={d}>
      <ellipse cx="9" cy="6.75" rx="6.5" ry="3.25" />
    </Duo>
    <ellipse cx="9" cy="6.75" rx="6.5" ry="3.25" />
    <path d="M2.5 6.75v4c0 1.8 2.9 3.25 6.5 3.25s6.5-1.45 6.5-3.25v-4" />
    <path d="M15.5 10.6c3.4.2 6 1.6 6 3.3v4c0 1.8-2.9 3.25-6.5 3.25-2.6 0-4.85-.76-5.9-1.85" />
    <path d="M2.5 10.75v4C2.5 16.55 5.4 18 9 18h.6" />
  </>
));

/** Логистика · доставка · фура (rd_collection, логистика) */
export const IconTruck = makeIcon("IconTruck", (d) => (
  <>
    <Duo on={d}>
      <path d="M4.5 5.5h8a2 2 0 0 1 2 2v10h-12v-10a2 2 0 0 1 2-2z" />
    </Duo>
    <path d="M2.5 17.5V7.5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v10" />
    <path d="M14.5 9.5h3.1a2 2 0 0 1 1.65.88l1.77 2.62a2 2 0 0 1 .48 1.3v3.2" />
    <path d="M2.5 17.5h2.8M9.7 17.5h5.6M19.7 17.5h1.8" />
    <circle cx="7.5" cy="17.5" r="2.2" />
    <circle cx="17.5" cy="17.5" r="2.2" />
  </>
));

/** Склад (warehouse) */
export const IconWarehouse = makeIcon("IconWarehouse", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 2.6 21.5 7v14h-19V7z" />
    </Duo>
    <path d="M2.5 21V7.9a1.5 1.5 0 0 1 .93-1.39l8-3.3a1.5 1.5 0 0 1 1.14 0l8 3.3A1.5 1.5 0 0 1 21.5 7.9V21" />
    <path d="M6.5 21v-6.5a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1V21" />
    <path d="M6.5 17.25h11" />
    <path d="M1.5 21h21" />
  </>
));

/** Остатки · коробки (stocks) */
export const IconStock = makeIcon("IconStock", (d) => (
  <>
    <Duo on={d}>
      <rect x="8.75" y="2.5" width="6.5" height="6.5" rx="1.75" />
    </Duo>
    <rect x="8.75" y="2.5" width="6.5" height="6.5" rx="1.75" />
    <rect x="2.5" y="13" width="6.5" height="6.5" rx="1.75" />
    <rect x="15" y="13" width="6.5" height="6.5" rx="1.75" />
    <path d="M12 9v1.75a2.25 2.25 0 0 1-2.25 2.25M12 9v1.75a2.25 2.25 0 0 0 2.25 2.25" />
  </>
));

/** Товар · коробка · поставка (package) */
export const IconPackage = makeIcon("IconPackage", (d) => (
  <>
    <Duo on={d}>
      <path d="m12 2.75 9 4.6v9.3l-9 4.6-9-4.6V7.35z" />
    </Duo>
    <path d="M20.5 7.35v9.3a1.5 1.5 0 0 1-.82 1.34l-7 3.58a1.5 1.5 0 0 1-1.36 0l-7-3.58a1.5 1.5 0 0 1-.82-1.34v-9.3a1.5 1.5 0 0 1 .82-1.34l7-3.58a1.5 1.5 0 0 1 1.36 0l7 3.58a1.5 1.5 0 0 1 .82 1.34z" />
    <path d="m3.6 6.6 8.4 4.3 8.4-4.3" />
    <path d="M12 10.9v10.35" />
  </>
));

/** Производство · фабрика (factory) */
export const IconFactory = makeIcon("IconFactory", (d) => (
  <>
    <Duo on={d}>
      <path d="M2.5 21v-9.5l6.5 3.75v-3.75l6.5 3.75V21z" />
    </Duo>
    <path d="M2.5 21v-9.24a.75.75 0 0 1 1.13-.65L9 14.25v-3.49a.75.75 0 0 1 1.13-.65L15.5 13.25V6.5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1V21" />
    <path d="M1.5 21h21" />
    <path d="M6 17.5v2M11.5 17.5v2M17.5 17.5v2" />
  </>
));

/** Блогеры · креаторы (bloggers) */
export const IconBlogger = makeIcon("IconBlogger", (d) => (
  <>
    <Duo on={d}>
      <circle cx="10.5" cy="8" r="3.75" />
    </Duo>
    <circle cx="10.5" cy="8" r="3.75" />
    <path d="M3.5 20.5a7 7 0 0 1 14 0" />
    <path d="m18.75 2.5 1.2 2.42 2.67.39-1.93 1.88.46 2.66-2.4-1.26-2.39 1.26.46-2.66-1.93-1.88 2.67-.39z" />
  </>
));

/** База знаний · вики (kb) */
export const IconBook = makeIcon("IconBook", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 6.6c-1.6-1.5-3.7-2.35-6-2.35H3.5v12.5H6c2.3 0 4.4.85 6 2.35z" />
    </Duo>
    <path d="M12 6.6c-1.6-1.5-3.7-2.35-6-2.35H4.5a1 1 0 0 0-1 1v11.5a1 1 0 0 0 1 1H6c2.3 0 4.4.85 6 2.35z" />
    <path d="M12 6.6c1.6-1.5 3.7-2.35 6-2.35h1.5a1 1 0 0 1 1 1v11.5a1 1 0 0 1-1 1H18c-2.3 0-4.4.85-6 2.35z" />
    <path d="M12 6.6v12.5" />
  </>
));

/** Гейт · согласование (is_gate, product_launch) */
export const IconGate = makeIcon("IconGate", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 2.6 20.5 5.5v6.4c0 4.6-3.4 8.4-8.5 9.5-5.1-1.1-8.5-4.9-8.5-9.5V5.5z" />
    </Duo>
    <path d="M12 2.6 20.5 5.5v6.4c0 4.6-3.4 8.4-8.5 9.5-5.1-1.1-8.5-4.9-8.5-9.5V5.5z" />
    <path d="m8.5 11.75 2.5 2.5 4.5-4.75" />
  </>
));

/** Справка · подсказка (HelpDot) */
export const IconHelp = makeIcon("IconHelp", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="9.5" />
    </Duo>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M9.4 9.25a2.7 2.7 0 0 1 5.25.9c0 1.8-2.65 2.7-2.65 2.7" />
    <Dot cx={12} cy={16.75} r={1.05} />
  </>
));

/** Настройки · параметры (settings) */
export const IconSettings = makeIcon("IconSettings", (d) => (
  <>
    <Duo on={d}>
      <circle cx="15.5" cy="6" r="2.6" />
      <circle cx="8.5" cy="18" r="2.6" />
    </Duo>
    <path d="M2.5 6h10.4M18.1 6h3.4" />
    <path d="M2.5 12h4.4M12.1 12h9.4" />
    <path d="M2.5 18h3.4M11.1 18h10.4" />
    <circle cx="15.5" cy="6" r="2.6" />
    <circle cx="9.5" cy="12" r="2.6" />
    <circle cx="8.5" cy="18" r="2.6" />
  </>
));

/** Настройки шестерёнкой (gear) — «цветочная», с восемью скруглёнными
 *  лепестками и кружком в центре.
 *
 *  ⚠️ ФОРМА СНЯТА С ОБРАЗЦА PLUX (photo_2026-08-25_22-44-30.jpg), а не выдумана.
 *  Первый заход был классической шестернёй с прямыми зубьями (lucide) — Максим:
 *  «глянь как у них шестерёнка выглядит и сделай нам так же». Замер значка на
 *  образце (16 px): глубина лепестка 0.172 от внешнего радиуса, внутренний край
 *  кружка 0.252 от него же. Контур — волна r(θ)=8.2+0.82·cos(8θ) по 32 точкам;
 *  на такой сетке замер даёт 0.18 и 0.258, то есть попадание в образец.
 *
 *  ⚠️ ЭТО НЕ ЗАМЕНА IconSettings. Тот — «ползунки», параметры экрана, ими
 *  подписаны настройки модулей. Шестерёнка нужна там, где человек ищет её
 *  глазами в углу экрана: панель в строке заголовка.
 */
export const IconGear = makeIcon("IconGear", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="3.2" />
    </Duo>
    <path d="M21.02 12C21.02 12.53 20.41 13.13 20.04 13.6C19.68 14.07 19.02 14.33 18.82 14.82C18.61 15.32 18.89 15.96 18.82 16.56C18.74 17.15 18.76 18 18.38 18.38C18 18.76 17.15 18.74 16.56 18.82C15.96 18.89 15.32 18.61 14.82 18.82C14.33 19.02 14.07 19.68 13.6 20.04C13.13 20.41 12.53 21.02 12 21.02C11.47 21.02 10.87 20.41 10.4 20.04C9.93 19.68 9.67 19.02 9.18 18.82C8.68 18.61 8.04 18.89 7.44 18.82C6.85 18.74 6 18.76 5.62 18.38C5.24 18 5.26 17.15 5.18 16.56C5.11 15.96 5.39 15.32 5.18 14.82C4.98 14.33 4.32 14.07 3.96 13.6C3.59 13.13 2.98 12.53 2.98 12C2.98 11.47 3.59 10.87 3.96 10.4C4.32 9.93 4.98 9.67 5.18 9.18C5.39 8.68 5.11 8.04 5.18 7.44C5.26 6.85 5.24 6 5.62 5.62C6 5.24 6.85 5.26 7.44 5.18C8.04 5.11 8.68 5.39 9.18 5.18C9.67 4.98 9.93 4.32 10.4 3.96C10.87 3.59 11.47 2.98 12 2.98C12.53 2.98 13.13 3.59 13.6 3.96C14.07 4.32 14.33 4.98 14.82 5.18C15.32 5.39 15.96 5.11 16.56 5.18C17.15 5.26 18 5.24 18.38 5.62C18.76 6 18.74 6.85 18.82 7.44C18.89 8.04 18.61 8.68 18.82 9.18C19.02 9.67 19.68 9.93 20.04 10.4C20.41 10.87 21.02 11.47 21.02 12Z" />
    <circle cx="12" cy="12" r="3.2" />
  </>
));

/** Конструктор темы · палитра (theme) */
export const IconPalette = makeIcon("IconPalette", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="9.5" />
    </Duo>
    <path d="M12 2.5a9.5 9.5 0 0 0 0 19 2.2 2.2 0 0 0 2.2-2.2c0-.58-.22-1.1-.58-1.5a2.2 2.2 0 0 1 1.63-3.68h2.13a4.12 4.12 0 0 0 4.12-4.12C21.5 5.98 17.25 2.5 12 2.5z" />
    <Dot cx={7.5} cy={12.75} r={1.15} />
    <Dot cx={9.25} cy={7.75} r={1.15} />
    <Dot cx={14.5} cy={6.75} r={1.15} />
    <Dot cx={17.75} cy={10.5} r={1.15} />
  </>
));

/** Пользователи · команда (users, hr) */
export const IconUsers = makeIcon("IconUsers", (d) => (
  <>
    <Duo on={d}>
      <circle cx="9.5" cy="7.75" r="3.75" />
    </Duo>
    <circle cx="9.5" cy="7.75" r="3.75" />
    <path d="M2.5 20.25a7 7 0 0 1 14 0" />
    <path d="M16.25 4.35a3.75 3.75 0 0 1 0 6.8" />
    <path d="M18.5 14.4a7 7 0 0 1 3 5.85" />
  </>
));

/** Пользователь · профиль (single user) */
export const IconUser = makeIcon("IconUser", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="7.75" r="4" />
    </Duo>
    <circle cx="12" cy="7.75" r="4" />
    <path d="M4.5 20.5a7.5 7.5 0 0 1 15 0" />
  </>
));

/* ═══════════════════════ ТРАНСПОРТ ═══════════════════════ */

/** Авиа-доставка (transport: air) */
export const IconPlane = makeIcon("IconPlane", (d) => (
  <>
    <Duo on={d}>
      <path d="M13.4 2.9c.75 0 1.35.6 1.35 1.35v5.1l6.75 3.9v2.4l-6.75-2.1v4.65l2.1 1.65v1.65L12 20.4l-4.85.1v-1.65l2.1-1.65V12.5L2.5 14.6v-2.4l6.75-3.9v-5.1c0-.75.6-1.35 1.35-1.35z" />
    </Duo>
    <path d="M12 2.5a1.5 1.5 0 0 1 1.5 1.5v4.9l7.5 4.35v2.35l-7.5-2.3V18l2.4 1.85v1.65L12 20.6l-3.9.9v-1.65L10.5 18v-4.7L3 15.6v-2.35L10.5 8.9V4A1.5 1.5 0 0 1 12 2.5z" />
  </>
));

/** Ж/Д-доставка (transport: rail) */
export const IconTrain = makeIcon("IconTrain", (d) => (
  <>
    <Duo on={d}>
      <rect x="5" y="2.5" width="14" height="15.5" rx="4" />
    </Duo>
    <rect x="5" y="2.5" width="14" height="15.5" rx="4" />
    <path d="M5 10h14" />
    <Dot cx={9} cy={14.25} r={1.15} />
    <Dot cx={15} cy={14.25} r={1.15} />
    <path d="M8.5 6.25h7" />
    <path d="m7.5 18-2 3.5M16.5 18l2 3.5" />
  </>
));

/* ═══════════════════════ ДЕЙСТВИЯ · ХРОМ ═══════════════════════ */

/** Поиск */
export const IconSearch = makeIcon("IconSearch", (d) => (
  <>
    <Duo on={d}>
      <circle cx="10.75" cy="10.75" r="7.25" />
    </Duo>
    <circle cx="10.75" cy="10.75" r="7.25" />
    <path d="m16.25 16.25 4.5 4.5" />
  </>
));

/** Фильтр · воронка */
export const IconFilter = makeIcon("IconFilter", (d) => (
  <>
    <Duo on={d}>
      <path d="M3.2 4.5h17.6l-6.8 8v7l-4 2v-9z" />
    </Duo>
    <path d="M3.2 5.85A1 1 0 0 1 4.1 4.5h15.8a1 1 0 0 1 .77 1.64l-6.42 7.7v5.62a1 1 0 0 1-.55.9l-3 1.5a1 1 0 0 1-1.45-.9v-7.12L3.43 6.14a1 1 0 0 1-.23-.29z" />
  </>
));

/** Экспорт · выгрузка (наружу из лотка) */
export const IconExport = makeIcon("IconExport", (d) => (
  <>
    <Duo on={d}>
      <path d="M3.5 14.5h17v4a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />
    </Duo>
    <path d="M3.5 14.5v4a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-4" />
    <path d="M12 3v11" />
    <path d="m7.75 7.25 4.25-4.25 4.25 4.25" />
  </>
));

/** Импорт · загрузка (внутрь лотка) */
export const IconImport = makeIcon("IconImport", (d) => (
  <>
    <Duo on={d}>
      <path d="M3.5 14.5h17v4a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2z" />
    </Duo>
    <path d="M3.5 14.5v4a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2v-4" />
    <path d="M12 14V3" />
    <path d="m7.75 9.75 4.25 4.25 4.25-4.25" />
  </>
));

/** Календарь · период (planning) */
export const IconCalendar = makeIcon("IconCalendar", (d) => (
  <>
    <Duo on={d}>
      <rect x="3.5" y="5.5" width="17" height="15" rx="3.5" />
    </Duo>
    <rect x="3.5" y="5.5" width="17" height="15" rx="3.5" />
    <path d="M3.5 10.25h17" />
    <path d="M8.25 2.75V6M15.75 2.75V6" />
    <Dot cx={8.25} cy={14.25} r={1} />
    <Dot cx={12} cy={14.25} r={1} />
    <Dot cx={15.75} cy={14.25} r={1} />
  </>
));

/** Время · история */
export const IconClock = makeIcon("IconClock", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="9.5" />
    </Duo>
    <circle cx="12" cy="12" r="9.5" />
    <path d="M12 6.75V12l3.5 2.25" />
  </>
));

/** Уведомления · колокольчик */
export const IconBell = makeIcon("IconBell", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 2.75a6.5 6.5 0 0 1 6.5 6.5v3.4l1.6 3.35H3.9l1.6-3.35v-3.4a6.5 6.5 0 0 1 6.5-6.5z" />
    </Duo>
    <path d="M18.5 9.25a6.5 6.5 0 0 0-13 0v3.4L3.9 16H20.1l-1.6-3.35z" />
    <path d="M9.75 19.25a2.4 2.4 0 0 0 4.5 0" />
  </>
));

/** Главная */
export const IconHome = makeIcon("IconHome", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 2.9 21 10v11H3V10z" />
    </Duo>
    <path d="M3 10.35a1.5 1.5 0 0 1 .56-1.17l7.5-6a1.5 1.5 0 0 1 1.88 0l7.5 6A1.5 1.5 0 0 1 21 10.35V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <path d="M9.25 21v-6a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1v6" />
  </>
));

/** AI · искры (вкладка AI, генерация) */
export const IconSparkles = makeIcon("IconSparkles", (d) => (
  <>
    <Duo on={d}>
      <path d="M10 2.75 12.1 8.4l5.65 2.1-5.65 2.1L10 18.25 7.9 12.6 2.25 10.5 7.9 8.4z" />
    </Duo>
    <path d="M10 2.75 12.1 8.4l5.65 2.1-5.65 2.1L10 18.25 7.9 12.6 2.25 10.5 7.9 8.4z" />
    <path d="m18.25 14.5 1 2.5 2.5 1-2.5 1-1 2.5-1-2.5-2.5-1 2.5-1z" />
  </>
));

/** Чат · сообщение */
export const IconChat = makeIcon("IconChat", (d) => (
  <>
    <Duo on={d}>
      <path d="M6 3.5h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6.4L7 20.4V16.5H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" />
    </Duo>
    <path d="M6 3.5h12a3 3 0 0 1 3 3v7a3 3 0 0 1-3 3h-6.4L7 20.4V16.5H6a3 3 0 0 1-3-3v-7a3 3 0 0 1 3-3z" />
    <Dot cx={8.5} cy={10} r={1.05} />
    <Dot cx={12} cy={10} r={1.05} />
    <Dot cx={15.5} cy={10} r={1.05} />
  </>
));

/** Задача · заявка (dev_requests) */
export const IconTask = makeIcon("IconTask", (d) => (
  <>
    <Duo on={d}>
      <rect x="5" y="4.5" width="14" height="16" rx="2.5" />
    </Duo>
    <path d="M9 4.5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2h-2" />
    <rect x="9" y="2.5" width="6" height="4" rx="1.5" />
    <path d="M8.5 11.5h7M8.5 15.5h4.5" />
  </>
));

/** Звезда · рейтинг · избранное */
export const IconStar = makeIcon("IconStar", (d) => (
  <>
    <Duo on={d}>
      <path d="m12 2.75 2.85 5.78 6.4.93-4.63 4.5 1.1 6.36L12 17.32l-5.72 3z" />
    </Duo>
    <path d="m12 2.75 2.85 5.78 6.4.93-4.63 4.5 1.1 6.36L12 17.32l-5.72 3 1.1-6.36-4.63-4.5 6.4-.93z" />
  </>
));

/** Просмотры · показать */
export const IconEye = makeIcon("IconEye", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="3.5" />
    </Duo>
    <path d="M1.75 12s3.75-6.75 10.25-6.75S22.25 12 22.25 12s-3.75 6.75-10.25 6.75S1.75 12 1.75 12z" />
    <circle cx="12" cy="12" r="3.5" />
  </>
));

/** Светлая тема */
export const IconSun = makeIcon("IconSun", (d) => (
  <>
    <Duo on={d}>
      <circle cx="12" cy="12" r="4.5" />
    </Duo>
    <circle cx="12" cy="12" r="4.5" />
    <path d="M12 2.6v2.8M12 18.6v2.8M18.6 12h2.8M2.6 12h2.8" />
    <path d="m16.7 7.3 2-2M5.3 18.7l2-2M16.7 16.7l2 2M5.3 5.3l2 2" />
  </>
));

/** Тёмная тема */
export const IconMoon = makeIcon("IconMoon", (d) => (
  <>
    <Duo on={d}>
      <path d="M20.8 14.6A9.2 9.2 0 1 1 9.4 3.2 8.6 8.6 0 0 0 20.8 14.6z" />
    </Duo>
    <path d="M20.8 14.6A9.2 9.2 0 1 1 9.4 3.2 8.6 8.6 0 0 0 20.8 14.6z" />
  </>
));

/** Готово · галка */
export const IconCheck = makeIcon("IconCheck", () => <path d="m4.5 12.5 5 5 10-11" />);

/** Закрыть · нет */
export const IconClose = makeIcon("IconClose", () => <path d="M5.5 5.5l13 13M18.5 5.5l-13 13" />);

/** Добавить */
export const IconPlus = makeIcon("IconPlus", () => <path d="M12 4.5v15M4.5 12h15" />);

/** Удалить */
export const IconTrash = makeIcon("IconTrash", (d) => (
  <>
    <Duo on={d}>
      <path d="M5.5 6.5h13l-1.1 12.6a2 2 0 0 1-2 1.9H8.6a2 2 0 0 1-2-1.9z" />
    </Duo>
    <path d="M3.5 6.5h17" />
    <path d="M18.5 6.5l-1.1 12.6a2 2 0 0 1-2 1.9H8.6a2 2 0 0 1-2-1.9L5.5 6.5" />
    <path d="M9 6.5V4.75a1.75 1.75 0 0 1 1.75-1.75h2.5A1.75 1.75 0 0 1 15 4.75V6.5" />
    <path d="M10.25 10.5v6.5M13.75 10.5v6.5" />
  </>
));

/** Редактировать */
export const IconEdit = makeIcon("IconEdit", (d) => (
  <>
    <Duo on={d}>
      <path d="m16.4 3.9 3.7 3.7-10.6 10.6-4.6.9.9-4.6z" />
    </Duo>
    <path d="M4.9 14.5 15.9 3.5a1.75 1.75 0 0 1 2.47 0l2.13 2.13a1.75 1.75 0 0 1 0 2.47l-11 11-5.15 1.05z" />
    <path d="m15.1 4.3 4.6 4.6" />
  </>
));

/** Внимание · предупреждение */
export const IconAlert = makeIcon("IconAlert", (d) => (
  <>
    <Duo on={d}>
      <path d="M12 3.4 22 20.5H2z" />
    </Duo>
    <path d="M10.27 4.4a2 2 0 0 1 3.46 0l8.2 14.1a2 2 0 0 1-1.73 3H3.8a2 2 0 0 1-1.73-3z" />
    <path d="M12 9.5v4.5" />
    <Dot cx={12} cy={17.5} r={1.05} />
  </>
));

/** Меню действий · «ещё» */
export const IconMore = makeIcon("IconMore", () => (
  <>
    <Dot cx={5.25} cy={12} r={1.5} />
    <Dot cx={12} cy={12} r={1.5} />
    <Dot cx={18.75} cy={12} r={1.5} />
  </>
));

/** Перетаскивание */
export const IconGrip = makeIcon("IconGrip", () => (
  <>
    <Dot cx={9} cy={5.5} r={1.4} />
    <Dot cx={15} cy={5.5} r={1.4} />
    <Dot cx={9} cy={12} r={1.4} />
    <Dot cx={15} cy={12} r={1.4} />
    <Dot cx={9} cy={18.5} r={1.4} />
    <Dot cx={15} cy={18.5} r={1.4} />
  </>
));

/** Обновить · синхронизация */
export const IconRefresh = makeIcon("IconRefresh", () => (
  <>
    <path d="M20.5 12a8.5 8.5 0 1 1-2.6-6.1" />
    <path d="M21 4v5h-5" />
  </>
));

/** Ссылка */
export const IconLink = makeIcon("IconLink", () => (
  <>
    <path d="M10 13.5a4 4 0 0 0 5.66 0l3.5-3.5a4 4 0 1 0-5.66-5.66l-1.5 1.5" />
    <path d="M14 10.5a4 4 0 0 0-5.66 0l-3.5 3.5a4 4 0 1 0 5.66 5.66l1.5-1.5" />
  </>
));

/** Вложение */
export const IconAttach = makeIcon("IconAttach", () => (
  <path d="M20 11.5 12.2 19.3a5.25 5.25 0 0 1-7.42-7.42l8.5-8.5a3.5 3.5 0 1 1 4.95 4.95l-8.5 8.5a1.75 1.75 0 1 1-2.48-2.48l7.8-7.8" />
));

/** Отправить */
export const IconSend = makeIcon("IconSend", (d) => (
  <>
    <Duo on={d}>
      <path d="M20.8 12 3.5 20.5l3-8.5-3-8.5z" />
    </Duo>
    <path d="M21.1 11.1a1 1 0 0 1 0 1.8l-16.6 8.16a1 1 0 0 1-1.39-1.23L6 12 3.11 4.17a1 1 0 0 1 1.39-1.23z" />
    <path d="M6 12h15" />
  </>
));

/** Закрепить столбец */
export const IconPin = makeIcon("IconPin", (d) => (
  <>
    <Duo on={d}>
      <path d="M9 3.5h6l-.75 5.25 3.25 3.25v2H6.5v-2l3.25-3.25z" />
    </Duo>
    <path d="M8.5 3.5h7a1 1 0 0 1 1 1.12l-.62 4.34 2.83 2.83a1 1 0 0 1 .29.71V13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-.5a1 1 0 0 1 .29-.71l2.83-2.83-.62-4.34a1 1 0 0 1 1-1.12z" />
    <path d="M12 14v6.5" />
  </>
));

/** Открепить столбец */
export const IconPinOff = makeIcon("IconPinOff", () => (
  <>
    <path d="M8.5 3.5h7a1 1 0 0 1 1 1.12l-.62 4.34 2.83 2.83a1 1 0 0 1 .29.71V13a1 1 0 0 1-1 1h-4" />
    <path d="M12 14v6.5" />
    <path d="M9.5 14H6a1 1 0 0 1-1-1v-.5a1 1 0 0 1 .29-.71l2.83-2.83-.29-2.02" />
    <path d="m3 3 18 18" />
  </>
));

/** Развернуть на весь экран */
export const IconExpand = makeIcon("IconExpand", () => (
  <>
    <path d="M9 3.5H5a1.5 1.5 0 0 0-1.5 1.5v4" />
    <path d="M15 3.5h4A1.5 1.5 0 0 1 20.5 5v4" />
    <path d="M15 20.5h4a1.5 1.5 0 0 0 1.5-1.5v-4" />
    <path d="M9 20.5H5A1.5 1.5 0 0 1 3.5 19v-4" />
  </>
));

/** Свернуть из полноэкранного */
export const IconCollapse = makeIcon("IconCollapse", () => (
  <>
    <path d="M3.5 9h4A1.5 1.5 0 0 0 9 7.5v-4" />
    <path d="M20.5 9h-4A1.5 1.5 0 0 1 15 7.5v-4" />
    <path d="M20.5 15h-4a1.5 1.5 0 0 0-1.5 1.5v4" />
    <path d="M3.5 15h4A1.5 1.5 0 0 1 9 16.5v4" />
  </>
));

/** Минус (уменьшить масштаб) — пара к IconPlus */
export const IconMinus = makeIcon("IconMinus", () => <path d="M4.5 12h15" />);

/** Вписать в экран (масштаб «по размеру холста») */
export const IconFit = makeIcon("IconFit", () => (
  <>
    <path d="M3.5 8.5v-3A2 2 0 0 1 5.5 3.5h3" />
    <path d="M20.5 8.5v-3a2 2 0 0 0-2-2h-3" />
    <path d="M20.5 15.5v3a2 2 0 0 1-2 2h-3" />
    <path d="M3.5 15.5v3a2 2 0 0 0 2 2h3" />
    <rect x="8.5" y="8.5" width="7" height="7" rx="1.5" />
  </>
));

/** Сортировка не задана */
export const IconSortNone = makeIcon("IconSortNone", () => (
  <>
    <path d="M8 8.5 12 4.5l4 4" />
    <path d="M8 15.5 12 19.5l4-4" />
  </>
));

/** Сортировка по возрастанию */
export const IconSortAsc = makeIcon("IconSortAsc", () => (
  <>
    <path d="M12 19.5v-15" />
    <path d="m6.5 10 5.5-5.5 5.5 5.5" />
  </>
));

/** Сортировка по убыванию */
export const IconSortDesc = makeIcon("IconSortDesc", () => (
  <>
    <path d="M12 4.5v15" />
    <path d="m6.5 14 5.5 5.5 5.5-5.5" />
  </>
));

/** Шеврон вниз (раскрыть) */
export const IconChevronDown = makeIcon("IconChevronDown", () => <path d="m6.5 9.5 5.5 5.5 5.5-5.5" />);
/** Шеврон вверх (свернуть) */
export const IconChevronUp = makeIcon("IconChevronUp", () => <path d="m6.5 14.5 5.5-5.5 5.5 5.5" />);
/** Шеврон вправо */
export const IconChevronRight = makeIcon("IconChevronRight", () => <path d="m9.5 6.5 5.5 5.5-5.5 5.5" />);
/** Шеврон влево */
export const IconChevronLeft = makeIcon("IconChevronLeft", () => <path d="m14.5 6.5-5.5 5.5 5.5 5.5" />);

/** Спиннер (крутить классом animate-spin на самой иконке) */
export const IconSpinner = makeIcon("IconSpinner", () => (
  <>
    <circle cx="12" cy="12" r="8.75" opacity={0.25} />
    <path d="M20.75 12A8.75 8.75 0 0 0 12 3.25" />
  </>
));
